export default function (value) {
  if (!value) return '';
  return `${value.slice(0, 3)} ${value.slice(3)}`;
}
